import React from "react";
import { Box, Button, Input, Select } from "@chakra-ui/react";

const ReusableFilter = ({
  searchValue = "",
  onSearchChange,
  fields = [],
  onFieldChange,
  onReset,
  searchPlaceholder = "Search...",
}) => {
  return (
    <Box
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="10px"
      p="14px"
      mb="14px"
    >
      <Box display="flex" flexWrap="wrap" gap="10px" alignItems="center">
        <Input
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(event) => onSearchChange?.(event.target.value)}
          w={["100%", "320px"]}
          flexShrink={0}
        />

        {fields.map((field) => {
          if (field.type === "select") {
            return (
              <Select
                key={field.key}
                size="sm"
                placeholder={field.placeholder || field.label}
                value={field.value || ""}
                onChange={(event) =>
                  onFieldChange?.(field.key, event.target.value)
                }
                w={["100%", "220px"]}
                flexShrink={0}
              >
                {(field.options || []).map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Select>
            );
          }

          return (
            <Input
              key={field.key}
              size="sm"
              type={field.type || "text"}
              placeholder={field.placeholder || field.label}
              value={field.value || ""}
              onChange={(event) =>
                onFieldChange?.(field.key, event.target.value)
              }
              w={["100%", "220px"]}
              flexShrink={0}
            />
          );
        })}

        <Button size="sm" variant="outline" onClick={onReset} flexShrink={0}>
          Reset
        </Button>
      </Box>
    </Box>
  );
};

export default ReusableFilter;
